import axios from "axios";
import Vue from "vue";
import router from "../router";
import store from "@/store";
import { BASEURL } from "@/config";
import cookieType from "@/config/cookieType";
import constantMessage from "@/helpers/constantMessage";

const status = true; //process.env.NODE_ENV !== "development"

export default () => {
  const instance = axios.create({
    baseURL: `${BASEURL}`
  });

  Vue.cookie.get(cookieType.MCHASHID)
    ? (instance.defaults.headers.common["Authorization"] = Vue.cookie.get(
      cookieType.MCHASHID
    ))
    : undefined;

  Vue.cookie.get(cookieType.CITYID)
    ? (instance.defaults.headers.common["city-id"] = Vue.cookie.get(
      cookieType.CITYID
    ))
    : undefined;
  instance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

  instance.interceptors.response.use(
    function (response) {
      // Do something with response data
      return response;
    },
    function (error) {
      console.log("error.response :>> ", error.response);
      // Do something with response error
      if (!error["response"]) {
        if (status) {
          showErrorMessage(error, constantMessage.connectivity);
          // redirect to auth page or login again
          // store.dispatch("onLogoutUser");
          // window.location.replace("login");
        }

        return Promise.reject(error);
      } else if (error.response.status == 403) {
        if (status) {
          showErrorMessage(error, constantMessage.AuthError);
          // redirect to auth page or login again
          // Vue.cookie.set(cookieType.MCHASHID, null);
          // window.location.replace("/");
        }
      } else if (error.response.status == 401) {
        if (status) {
          showErrorMessage(error, constantMessage.AdminError);
          // redirect to auth page or login again
          Vue.cookie.set(cookieType.MCHASHID, null);
          window.location.replace("/");
        }
      } else {
        showErrorMessage(error, constantMessage.AdminError);
      }
      return Promise.reject(error.response);
    }
  );
  return instance;
};
const showErrorMessage = (error, message) => {
  store.dispatch("AppSetting/showErrorNotification", {
    message: error["response"]
      ? error.response.data.message || message
      : message
  });
};



// WEBPACK FOOTER //
// ./src/apiServices/Api.js